// Capture-time review warning for Takeoff.
//
// A Takeoff Item's quantity counts every active measurement EXCEPT those
// with review_status = 'rejected' (see takeoff_item_aggregated_quantity).
// Measurements that are 'unreviewed' or 'pending' still count, because some
// workflows do not use formal review at all. So before a quantity is
// captured into a BOQ item, the user is told how many of the measurements
// inside it have not completed review, and must explicitly continue.
//
// This module only COUNTS statuses and builds a message. It never
// calculates or changes a quantity -- the quantity itself always comes
// from the database view.

export const OPEN_REVIEW_STATUSES = ['unreviewed', 'pending']

// rows: [{ review_status }] -- active measurements of the item, already
// filtered to OPEN_REVIEW_STATUSES by the caller (counted defensively anyway).
export function countOpenReviews(rows) {
  const counts = { unreviewed: 0, pending: 0 }
  for (const r of rows || []) {
    if (r.review_status === 'unreviewed') counts.unreviewed++
    else if (r.review_status === 'pending') counts.pending++
  }
  return counts
}

// Returns null when there is nothing to warn about (no open measurements).
export function buildCaptureReviewWarning({ unreviewed = 0, pending = 0 } = {}) {
  const total = unreviewed + pending
  if (total <= 0) return null
  const parts = []
  if (unreviewed > 0) parts.push(`${unreviewed} unreviewed`)
  if (pending > 0) parts.push(`${pending} pending review`)
  return (
    `This quantity includes ${total} measurement${total === 1 ? '' : 's'} that ` +
    `${total === 1 ? 'has' : 'have'} not completed review (${parts.join(', ')}).\n\n` +
    `Accepted, unreviewed and pending measurements are all counted; rejected measurements are already excluded.\n\n` +
    `Capture this quantity into the BOQ item anyway?`
  )
}
